"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableValue = void 0;
const KeyCodes_1 = __importDefault(require("@opsbase/lib-general/KeyCodes"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importStar(require("@opsbase/web-css"));
const AddIcon_1 = __importDefault(require("@opsbase/web-icons/icons/AddIcon"));
const ChevronDownIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronDownIcon"));
const ChevronRightIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ChevronRightIcon"));
const DeleteIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DeleteIcon"));
const GrabIcon_1 = __importDefault(require("@opsbase/web-icons/icons/GrabIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const TextField_1 = __importDefault(require("@opsbase/web-textfield/TextField"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const react_1 = __importStar(require("react"));
const makeMyClasses = (isSaved, shouldLightenExpanded, isPlaceHolder, toneDown, maxWidth) => ({
    root: {
        '& .showOnHover': {
            opacity: 0,
            pointerEvents: 'none',
        },
        '&:hover .showOnHover': {
            opacity: 1,
            pointerEvents: 'unset',
        },
    },
    inputRoot: {
        transition: 'background-color 0.3s',
    },
    mainBox: {
        overflow: 'hidden',
        background: isPlaceHolder
            ? lib_palette_1.default.secondary.background
            : toneDown
                ? lib_palette_1.default.BackgroundGrey.main
                : lib_palette_1.default.White.main,
        border: `1px solid ${lib_palette_1.default.InputBorderGrey.main}`,
        borderRadius: 4,
        padding: '2px 8px',
        margin: 4,
    },
    input: {
        maxWidth: maxWidth,
        '&::placeholder': {
            opacity: 1,
            color: lib_palette_1.default.secondary.main + ' !important',
        },
    },
    error: {
        backgroundColor: lib_palette_1.default.CoralRed.background,
    },
    grabIcon: {
        color: lib_palette_1.default.PastelBlue.main,
        cursor: 'grab',
        ['&:active']: {
            cursor: 'grabbing',
        },
        ['&:hover']: {
            color: lib_palette_1.default.BlackCoral.main,
        },
    },
    expandIcon: {
        color: shouldLightenExpanded ? lib_palette_1.default.PastelBlue.main : lib_palette_1.default.BlackCoral.main,
        cursor: 'pointer',
        ['&:hover']: {
            color: lib_palette_1.default.BlackCoral.main,
        },
    },
    deleteButton: {
        marginRight: -4,
        marginLeft: 4,
    },
    deleteIcon: {
        color: lib_palette_1.default.PastelBlue.main,
        ['&:hover']: {
            color: lib_palette_1.default.CoralRed.main,
        },
    },
});
function EditableValue(props) {
    const { selected = false, expanded = false, saved = true, multiline = false, maxWidth = 200, value = '', placeholder, lightenExpander = false, before, after, spaceForExpand = false, canExpand = false, canDrag = false, canDelete = false, disabled = false, onToggleExpand, onDelete, onMouseEnter, onMouseLeave, onSelect, onSelectNext, onSelectPrev, onReturnKey, onChange, onPaste, toneDown = false, } = props;
    const [currentValue, setCurrentValue] = (0, react_1.useState)(value);
    const [dirty, setDirty] = (0, react_1.useState)(false);
    const [inputRef, setInputRef] = (0, react_1.useState)();
    const startRef = (0, react_1.useRef)();
    const endRef = (0, react_1.useRef)();
    const isPlaceHolder = !!placeholder;
    const myCss = (0, web_css_1.default)(makeMyClasses, [saved, lightenExpander, isPlaceHolder, toneDown, maxWidth]);
    (0, react_1.useEffect)(() => {
        if (selected && inputRef && !(inputRef === null || inputRef === void 0 ? void 0 : inputRef.focused)) {
            inputRef.focus();
            inputRef.select();
        }
        if (!selected && (inputRef === null || inputRef === void 0 ? void 0 : inputRef.focused))
            inputRef.blur();
    }, [selected, inputRef]);
    const startAdornment = (0, react_1.useMemo)(() => {
        if (isPlaceHolder)
            return (react_1.default.createElement(Pane_1.default, null,
                react_1.default.createElement(AddIcon_1.default, { htmlColor: lib_palette_1.default.secondary.main, marginRight: 8 })));
        return (before === null || before === void 0 ? void 0 : before(startRef.current)) || null;
    }, [before, isPlaceHolder, startRef]);
    const endAdornment = (0, react_1.useMemo)(() => (after === null || after === void 0 ? void 0 : after(endRef.current)) || null, [after, endRef]);
    const doSave = (0, react_1.useMemo)(() => () => {
        if (dirty) {
            setDirty(false);
            onChange(currentValue.trim());
        }
        if (placeholder) {
            setCurrentValue('');
        }
    }, [currentValue, dirty, onChange, placeholder]);
    const handleKeyDown = (0, react_1.useCallback)((e) => {
        switch (e.keyCode) {
            case KeyCodes_1.default.ESC:
                e.preventDefault();
                setCurrentValue(value);
                break;
            case KeyCodes_1.default.ENTER:
                e.preventDefault();
                doSave();
                onReturnKey === null || onReturnKey === void 0 ? void 0 : onReturnKey();
                break;
            case KeyCodes_1.default.BACKSPACE:
                if (currentValue === '') {
                    e.preventDefault();
                    onDelete === null || onDelete === void 0 ? void 0 : onDelete();
                }
                break;
            case KeyCodes_1.default.UP:
                onSelectPrev === null || onSelectPrev === void 0 ? void 0 : onSelectPrev();
                break;
            case KeyCodes_1.default.DOWN:
                onSelectNext === null || onSelectNext === void 0 ? void 0 : onSelectNext();
                break;
        }
    }, [currentValue, doSave, onDelete, onReturnKey, onSelectNext, onSelectPrev, value]);
    const handleChangeValue = (0, react_1.useCallback)(newValue => {
        setDirty(value !== newValue);
        setCurrentValue(newValue);
    }, [value]);
    const handlePaste = (0, react_1.useCallback)(e => {
        let pastedText = e.clipboardData.getData('Text');
        if (pastedText.indexOf('\n') > -1 && onPaste) {
            // if we have unsaved text in the placeholder add it to the beginning of the paste string
            if (placeholder) {
                pastedText = currentValue.trim() + '\n' + pastedText;
                handleChangeValue('');
            }
            e.preventDefault();
            onPaste(pastedText, currentValue.trim() === '');
        }
    }, [currentValue, handleChangeValue, onPaste, placeholder]);
    const handleFocus = (0, react_1.useCallback)(() => {
        if (!selected)
            onSelect === null || onSelect === void 0 ? void 0 : onSelect();
    }, [onSelect, selected]);
    const handleBlur = (0, react_1.useCallback)(() => doSave(), [doSave]);
    const handleClick = (0, react_1.useCallback)(() => {
        inputRef === null || inputRef === void 0 ? void 0 : inputRef.focus();
        inputRef === null || inputRef === void 0 ? void 0 : inputRef.select();
    }, [inputRef]);
    const handleClickInput = (0, react_1.useCallback)(e => e.stopPropagation(), []);
    return (react_1.default.createElement(Horizontal_1.default, { centered: true, classes: { root: myCss.root }, onClick: handleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        spaceForExpand && (react_1.default.createElement(Pane_1.default, { style: { width: 24 } },
            canExpand && !expanded && (react_1.default.createElement(ChevronRightIcon_1.default, { className: myCss.expandIcon + (lightenExpander ? ' showOnHover' : ''), onClick: onToggleExpand })),
            canExpand && expanded && (react_1.default.createElement(ChevronDownIcon_1.default, { className: myCss.expandIcon + (lightenExpander ? ' showOnHover' : ''), onClick: onToggleExpand })))),
        canDrag && (react_1.default.createElement(Pane_1.default, { style: { width: 24 } }, !disabled && (react_1.default.createElement(GrabIcon_1.default, { className: myCss.grabIcon + ' dragHandle showOnHover' })))),
        react_1.default.createElement(Horizontal_1.default, { gutter: true, centered: true, classes: { root: (0, web_css_1.cx)('EditableValue', myCss.mainBox) } },
            react_1.default.createElement("div", { ref: startRef }, startAdornment),
            react_1.default.createElement(TextField_1.default, { disabled: disabled, multiline: multiline, fullWidth: true, noMargin: true, noBorder: true, value: currentValue, InputProps: {
                    classes: {
                        root: myCss.inputRoot,
                        input: myCss.input,
                        error: myCss.error,
                    },
                    inputProps: disabled ? { tabIndex: -1 } : {},
                }, inputRef: setInputRef, placeholder: placeholder, onClick: handleClickInput, onKeyDown: handleKeyDown, onFocus: handleFocus, onBlur: handleBlur, onPaste: handlePaste, onChange: handleChangeValue }),
            react_1.default.createElement("div", { ref: endRef }, endAdornment)),
        react_1.default.createElement(Pane_1.default, { style: { width: 24 } }, !disabled && canDelete && (react_1.default.createElement(IconButton_1.default, { onClick: onDelete, classes: { root: myCss.deleteButton + ' hideOnDrag showOnHover' }, icon: react_1.default.createElement(DeleteIcon_1.default, { className: myCss.deleteIcon }) })))));
}
exports.EditableValue = EditableValue;
exports.default = EditableValue;
